<template lang="html">
  <div>
    <add-users-steps-bar
      :stepActive="stepActive"
      @nextScreen="nextScreen"
      v-if="screen < 2"
    />
    <add-courses-upload-csv v-if="screen === 1" />
    <add-users-third-step v-else-if="screen === 2" />
  </div>
</template>
<script>
  import { EventBus } from 'utils/event-bus';
  import addUsersStepsBar from 'features/admin/adminPortal/adminPortalUsers/addUsers/addUsersStepsBar';
  import addCoursesUploadCsv from './addCoursesUploadCsv';
  import addUsersThirdStep from 'features/admin/adminPortal/adminPortalUsers/addUsers/addUsersThirdStep';

  export default {
    data() {
      return {
        screen: '',
        stepActive: null,
      };
    },
    components: {
      addUsersStepsBar,
      addCoursesUploadCsv,
      addUsersThirdStep,
    },
    methods: {
      selectCSV() {
        this.stepActive = 1;
      },
      nextScreen(screen) {
        this.screen = screen;
      },
    },
    created() {},
    mounted() {
      this.screen = 1;
      EventBus.$on('reloadAddCourses', () => (this.screen = 1));
    },
    beforeDestroy() {
      EventBus.$off('reloadAddCourses');
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .selected-style {
    border-width: 5px;
    border-style: solid;
    color: pl-primary;
    border-color: pl-primary;
  }
</style>



// WEBPACK FOOTER //
// adminPortalAddCourses.vue?5f9cd9a2